import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import GeneralInfoHeader from './components/GeneralInfoHeader';
import InfoCards from './components/InfoCards';
import VenueSection from './components/VenueSection';

const GeneralInfoPage = () => {
  return (
    <>
      <title>Genel Bilgiler & Mekan | İstanbul Dental Kongresi 2026</title>
      <meta name="description" content="İstanbul Dental Kongresi 2026 genel bilgiler, kongre mekanı ve konaklama seçenekleri. İstanbul Atlas Üniversitesi Kongre Merkezi'nde 2-3 Mayıs 2026. Ulaşım ve konaklama bilgileri." />
      <meta name="keywords" content="istanbul dental kongresi mekan, atlas üniversitesi kongre merkezi, dental kongre konaklama istanbul" />
      <link rel="canonical" href="https://ankaradentalkongresi.com/genel-bilgiler" />
      <meta property="og:title" content="Genel Bilgiler & Mekan | İstanbul Dental Kongresi 2026" />
      <meta property="og:description" content="Kongre mekanı, konaklama ve ulaşım bilgileri. İstanbul Atlas Üniversitesi Kongre Merkezi, 2-3 Mayıs 2026." />
      <meta property="og:url" content="https://ankaradentalkongresi.com/genel-bilgiler" />
      <div className="min-h-screen bg-white">
        <Navbar />
        <GeneralInfoHeader />
        <VenueSection />
        <InfoCards />
        <Footer />
      </div>
    </>
  );
};

export default GeneralInfoPage;
